// Modules
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Textarea from 'react-textarea-autosize';
import _ from 'lodash';

import { ignoreEnter } from 'utils/event-handlers';
import { isMobile } from 'constants';
import UserInitials from 'components/models/user/user-initials';

export default class TaskNotes extends React.Component {
  static propTypes = {
    updateTask: PropTypes.func.isRequired,
    closeTask: PropTypes.func.isRequired,
    task: PropTypes.object.isRequired,
    isLastClosedTask: PropTypes.bool,
    currentUser: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = { description: this.props.task.description || '' };

    this.updateDescription = this.updateDescription.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.updateTask = this.updateTask.bind(this);
    this.debounceUpdateTask = _.debounce(this.updateTask, 700);
  }

  componentDidUpdate(prevProps) {
    const open = this.props.task.open;
    const wasOpen = prevProps.task.open;

    if (open && !wasOpen && !isMobile) ReactDOM.findDOMNode(this.input).focus();
  }

  onBlur() {
    if (this.state.description !== this.props.task.description) this.updateTask();
  }

  onEnter() {
    this.props.closeTask();
    this.updateTask();
  }

  updateDescription(event) {
    this.setState({ description: event.target.value });
    this.debounceUpdateTask();
  }

  updateTask() {
    this.debounceUpdateTask.cancel();
    this.props.updateTask({ description: this.state.description });
  }

  render() {
    const { task, currentUser } = this.props;
    const { description } = this.state;
    const complete = task.status === 'Complete';
    const completedBy = (complete && !task.completedBy) ? currentUser.id : task.completedBy;

    return (
      <div className="description-wrapper">
        { complete &&
          <div className="completed-by">
            (<UserInitials userId={completedBy} />)
          </div>
        }
        <div className="description">
          { (!task.open || complete) && description }
          { task.open && !complete &&
            <Textarea
              ref={input => { this.input = input; }}
              onKeyPress={ignoreEnter(this.onEnter)}
              className="unstyled-textarea"
              value={description}
              onChange={this.updateDescription}
              onBlur={this.onBlur}
            />
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/ticket/task-description.js